import { format } from 'date-fns'

export default function formatDate (value: Date) {
  return value ? format(value, 'MMMM d, yyyy') : ''
}

export function formatDateTime (value: Date) {
  return value ? format(value, 'MMMM d - h:mm aaa') : ''
}
